import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacActionObjectEntity } from './rbac-action-object.entity';

@Index(
	'_fk__rbac_role_object__id',
	['fkRbacActionObjectId', 'action', 'crudOwner'],
	{ unique: true },
)
@Entity('_rbac_action__object__crud')
export class RbacActionObjectCrudEntity extends BaseEntity {
	@Column('int', { name: '_fk__rbac_action__object__id', unsigned: true })
	public fkRbacActionObjectId!: number;

	@Column('varchar', { name: '_action', length: 64 })
	public action!: string;

	@Column('varchar', { name: '_owner', nullable: true, length: 64 })
	public crudOwner!: string | null;

	@Column({ type: 'boolean', name: '_canHaveAll', nullable: true, width: 1 })
	public canHaveAll!: boolean | null;

	@ManyToOne(
		() => RbacActionObjectEntity,
		(rbacActionObject) => rbacActionObject.rbacActionObjectCruds,
		{ onDelete: 'CASCADE', onUpdate: 'CASCADE' },
	)
	@JoinColumn([
		{ name: '_fk__rbac_action__object__id', referencedColumnName: 'id' },
	])
	public fkRbacActionObject!: RbacActionObjectEntity;
}
